import angular from 'angular';
import uiRouter from 'angular-ui-router';
import awaitingreviewComponent from './awaitingreview.component';

let awaitingreviewModule = angular.module('awaitingreview', [
  uiRouter
])

.component('awaitingreview', awaitingreviewComponent);

export default awaitingreviewModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/awaitingreview/awaitingreview.js